<template>
  <div class="payment">
    Loading...
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import {loadStripe} from '@stripe/stripe-js'

export default {
  name: 'Payment',
  async mounted() {
    const stripe = await loadStripe('pk_live_saF4u3oX1Ek4E2VowUMWKfxw')
    let createFn = firebase.functions().httpsCallable('createCheckoutSession')
    createFn().then(res => {
      if (res.data && res.data.id) {
        stripe.redirectToCheckout({ sessionId: res.data.id })
      } else {
        this.$router.replace('/')
      }
    })
  },
}
</script>
<style scoped>
.payment {
  padding: 5rem 0;
  text-align: center;
}
</style>
